import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import process from './modules/process';
import processTracking from './modules/processTracking';
import acceso from './modules/acceso';

Vue.use(Vuex);
Vue.config.devtools = true

export default new Vuex.Store({
  modules: { auth, process, processTracking, acceso },
  
});
